const readJsonPayload = async (data) => {
  if (data && typeof data.text === 'function') {
    return JSON.parse(await data.text());
  }
  if (typeof data === 'string') {
    return JSON.parse(data);
  }
  if (data && typeof data === 'object') {
    return data;
  }
  throw new Error('Export queue response was not valid JSON');
};

export const normalizeExportResponse = async (response) => {
  if (response?.status !== 202) {
    return {
      kind: 'download',
      blob: response?.data,
    };
  }

  const exportJob = await readJsonPayload(response.data);
  if (!exportJob?.export_job_id || exportJob.async !== true) {
    throw new Error('Export queue response is missing export_job_id');
  }

  return {
    kind: 'queued',
    exportJob,
  };
};
